import { useMemo } from "react";
import buffer from "@turf/buffer";
import convex from "@turf/convex";
import { useMapLayer } from "react-migration/lib/map/useMapLayer";
import { SelectionGeometry } from "src/js/stores/map/store";
import { useRadiusBufferLayer } from "./useRadiusBufferLayer";
import { Color } from "deck.gl";

type UseRadiusBufferProps = {
  geometry?: SelectionGeometry | null;
  bufferMeters: number;
  enabled: boolean;
  color?: Color;
  zOrder?: number;
};

export function useRadiusBuffer({ geometry, bufferMeters, enabled, color, zOrder = 1000 }: UseRadiusBufferProps) {
  const bufferFeature = useMemo(() => {
    if (!enabled || !geometry) return undefined;
    if (bufferMeters === 0) {
      return buffer(geometry, bufferMeters, { units: "meters" });
    }

    const convexed = convex(geometry);
    return convexed ? buffer(convexed, bufferMeters, { units: "meters" }) : undefined;
  }, [enabled, bufferMeters, geometry]);

  const layer = useRadiusBufferLayer({ feature: bufferFeature, color });

  useMapLayer(
    () => ({
      layer,
      zOrder: zOrder,
    }),
    [layer, zOrder]
  );
}
